// src/plugins/index.js
import axiosPlugin from './axios';
import aadhaarAxios from './aadhar-axios';
import bankVerificationAxios from './bank-verification-axios';
import modicareKycAxios from './modicare-kyc-axios';
import { createVfm } from 'vue-final-modal';
import { createPinia } from 'pinia';
import piniaPersistedstate from 'pinia-plugin-persistedstate';
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
// import quasarUserOptions from '../quasar-user-options'
import Quasar from 'quasar/src/vue-plugin.js';
// import vuetify from "@/plugins/vuetify";
import '@quasar/extras/material-icons/material-icons.css'
// import Vue3FormWizard from 'vue3-form-wizard';
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/common/images/wqa/icons/index.js'

// import { QuillEditor } from '@vueup/vue-quill';
// import 'quill/dist/quill.snow.css';

const pinia = createPinia();
pinia.use(piniaPersistedstate);
const options = {
  hideProgressBar: true,
  timeout: 2000,
};
export default {
  install(app) {
    app.provide('icons', icons)
    app.use(axiosPlugin);
    app.use(aadhaarAxios);
    // app.use(Vue3FormWizard);
    // app.use(QuillEditor);
    app.use(Quasar);
    app.use(CoreuiVue);
    app.use(CIcon);
    app.use(bankVerificationAxios);
    app.use(modicareKycAxios);
    app.use(createVfm());
    app.use(pinia);
    // app.use(vuetify);
    app.use(Toast, options);
  },
};
